/** Quiet retries after a transient /users/me failure. */
export const USER_RETRY_DELAYS_MS = [4000, 8000, 16000];

/**
 * A failed read keeps the last good user and stays loaded.
 * The full-app loading screen is only for the first attempt.
 */
/** Clerk user objects are new on every refresh. The fields are what matter. */
export function sameClerkUser(left, right) {
  if (left === right) return true;
  if (!left || !right) return false;
  const email = (record) => record.primaryEmailAddress?.emailAddress || record.email || null;
  const name = (record) => record.fullName || record.firstName || record.displayName || null;
  const role = (record) => record.publicMetadata?.role || record.role || null;
  return (left.id || null) === (right.id || null)
    && email(left) === email(right)
    && name(left) === name(right)
    && (left.imageUrl || null) === (right.imageUrl || null)
    && role(left) === role(right);
}

/** A repeat /users/me with the same account must not publish a new object. */
export function sameBackendUser(left, right) {
  if (left === right) return true;
  if (!left || !right) return false;
  return String(left.id || '') === String(right.id || '')
    && (left.role || null) === (right.role || null)
    && Boolean(left.is_admin) === Boolean(right.is_admin)
    && (left.email || null) === (right.email || null);
}

export function settleUserLoad({ previousUser = null, incoming = null, failed = false } = {}) {
  if (!failed && incoming) {
    if (sameBackendUser(previousUser, incoming)) {
      return { user: previousUser, loaded: true, retry: false };
    }
    return { user: incoming, loaded: true, retry: false };
  }
  return { user: previousUser ?? null, loaded: true, retry: true };
}

/** Once the shell has been shown, a later unreadiness must not replace it. */
export function keepAppShell({ ready = false, shellShown = false } = {}) {
  return Boolean(ready || shellShown);
}

/** A signed-out flicker must not navigate away and tear down an open stream. */
export const SIGN_OUT_HOLD_MS = 800;

export function signOutStillHeld({
  shellShown = false,
  signedOut = false,
  heldSince = null,
  now = Date.now(),
} = {}) {
  if (!shellShown || !signedOut || heldSince == null) return false;
  return now - heldSince < SIGN_OUT_HOLD_MS;
}
